'use es6';

import getProperties from '../properties/index';
import * as PropertyTypes from '../constants/property-types';
export function getBlocklistedForDrilldown(dataType) {
  return getProperties(dataType).then(properties => {
    const dataTypeProperties = properties.get(dataType);
    return dataTypeProperties.filter(property => property.get('type') === PropertyTypes.BUCKETS && property.get('name') !== 'BUCKET_dealProgress').map(property => property.get('name')).toSet();
  });
}